import React from "react";
import Seo from "../components/Seo";
import { ROUTE_META } from "../seo/siteMeta.mjs";

const Accessibility = () => {
  return (
    <div className="dd-page" data-page="legal">
      <Seo
        path="/accessibility"
        title={ROUTE_META["/accessibility"].title}
        description={ROUTE_META["/accessibility"].description}
      />

      <div className="wrap section">
        <h1 tabIndex={-1}>Accessibility</h1>
        <div className="prose">
          <p>Dark Defensive is committed to making this website usable by everyone, including people who use screen readers, keyboard navigation, screen magnification, speech input, or other assistive technology.</p>

          <h2>Our standard</h2>
          <p>We aim to meet the Web Content Accessibility Guidelines (WCAG) 2.1 at Level AA.</p>

          <h2>What we have built in</h2>
          <ul>
            <li>A skip link to jump straight to the main content.</li>
            <li>Landmark regions for the header, navigation, main content, and footer.</li>
            <li>Headings in a logical order on every page.</li>
            <li>Visible keyboard focus on every link, button, and form field.</li>
            <li>Text alternatives for images, icons, and the product console preview.</li>
            <li>Form fields with permanent visible labels, required-field indicators, and error messages that explain what went wrong and how to fix it.</li>
            <li>Errors announced to screen readers and linked to the field they describe.</li>
            <li>Expandable sections that report their open or closed state.</li>
            <li>Testimonials that pause on hover and on keyboard focus, and that stop moving when reduced motion is requested.</li>
          </ul>

          <h2>Known limitations</h2>
          <p>Some third-party content may not fully meet our standard. We review and correct issues as we find them.</p>

          <h2>Tell us about a barrier</h2>
          <p>If any part of this site is difficult to use, email <a href="mailto:info@darkdefensive.com">info@darkdefensive.com</a> and describe the page and the problem. We will respond and work with you to provide the information you need in an accessible format.</p>
        </div>
      </div>
    </div>
  );
};

export default Accessibility;
